import { useEffect, useState } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import URLs from "./pages/urls";
import ErrorBoundary from './components/ErrorBoundary';
import { AuthProvider } from './components/AuthContext';
import { BasketProvider } from './components/BasketContext';
import { MenuProvider } from './components/MenuContext';
import { CategoryProvider } from './components/CategoryContext';

const IDLE_TIMEOUT = 4 * 60 * 60 * 1000; // 4 hours in milliseconds

const App = () => {
  const [lastActivity, setLastActivity] = useState(Date.now());

  useEffect(() => {
    const updateLastActivity = () => setLastActivity(Date.now());
    
    window.addEventListener('mousemove', updateLastActivity);
    window.addEventListener('click', updateLastActivity);
    window.addEventListener('keypress', updateLastActivity);
    window.addEventListener('scroll', updateLastActivity);
    window.addEventListener('touchstart', updateLastActivity);

    return () => {
      window.removeEventListener('mousemove', updateLastActivity);
      window.removeEventListener('click', updateLastActivity);
      window.removeEventListener('keypress', updateLastActivity);
      window.removeEventListener('scroll', updateLastActivity);
      window.removeEventListener('touchstart', updateLastActivity);
    };
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (Date.now() - lastActivity >= IDLE_TIMEOUT) {
        window.location.reload();
      }
    }, 60000);

    return () => clearInterval(intervalId);
  }, [lastActivity]);

  return (
    <ErrorBoundary>
      <HelmetProvider>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <AuthProvider>
            <BasketProvider>
              <MenuProvider>
                <CategoryProvider>
                  <div className="min-h-screen" style={{ overflowX: 'clip' }}>
                    <URLs />
                  </div>
                </CategoryProvider>
              </MenuProvider>
            </BasketProvider>
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </ErrorBoundary>
  );
};

export default App;
